import { Message } from 'element-ui'
import axios from 'axios'

/** 支付接口 */
const paymentUrl = process.env.VUE_APP_PaymentUrl
/** 出入库接口 */
const warehousingUrl = process.env.VUE_APP_WarehousingUrl
/** 出入库项目Openid */
const warehousingOpenid = process.env.VUE_APP_WarehousingOpenid
/** 出入库项目Token */
const warehousingToken = process.env.VUE_APP_WarehousingToken

/**
 * 支付请求实例
 */
const paymentReq = axios.create({
  baseURL: paymentUrl
})

/**
 * 支付响应拦截器
 */
paymentReq.interceptors.response.use(
  response => {
    const result = response.data
    if (result.code !== 0) {
      return Promise.reject(result.message)
    } else {
      return result
    }
  },
  error => {
    Message({
      message: '服务器数据错误，请稍候再试',
      type: 'error',
      duration: 1.5 * 1000
    })
    return Promise.reject(error)
  }
)

/**
 * 出入库请求实例
 */
const warehousingReq = axios.create({
  baseURL: warehousingUrl
})

/**
 * 出入库请求拦截器
 */
warehousingReq.interceptors.request.use((config) => {
  config.headers['Token'] = warehousingToken
  config.headers['OpenID'] = warehousingOpenid
  return config
})

/**
 * 出入库响应拦截器
 */
warehousingReq.interceptors.response.use((response) => {
  const result = response.data
  if (result.status !== '0') {
    return Promise.reject(result.message)
  } else {
    return result
  }
})

export {
  paymentReq, warehousingReq
}
